<template>
  <div
    class="page-header-container"
    :class="{
      'about-start': $route.name === 'page-about',
      'aoubt-2-has-played': about2hasPlayed,
      'aoubt-4-has-played': about4hasPlayed,
      'home-start': $route.name === 'page-home',
      'home-mobile': $bowser.mobile && $route.name === 'page-home',
      'home-transition-end': $bowser.mobile && $route.name === 'page-home' && homeTransitionEnd,
      hidden: normalHidden,
      whiteShow: whiteShow,
      menuOpened: $store.state.subMeunSwitch,
      mobileMemberDetailShow: $store.state.mobileMemberDetailShow
    }"
  >
    <div class="header__inner" ref="normal">
      <router-link
        class="logo"
        tag="div"
        :to="{
          path: '/'
        }"
        :class="{
          menuOpened: $store.state.subMeunSwitch
        }"
      >
        <div class="main-logo"></div>
        <div class="sub-logo"></div>
      </router-link>
      <div
        class="menu"
        @click="onClick"
        :class="{
          clicked: $store.state.subMeunSwitch
        }"
        v-if="$route.meta.isHiddenMenu !== true"
      >
        <div class="menu__text">
          <p>menu</p>
          <p>close</p>
        </div>
        <div class="menu__icon"><i></i><i></i></div>
      </div>
    </div>
  </div>
</template>

<script>
// import { throttle } from '@/utils/common';

export default {
  name: 'c__header',
  data() {
    return {
      homeTransitionEnd: false,
      normalHidden: false,
      whiteShow: false,
      touchStartPagetY: 0,
    };
  },
  computed: {
    about2hasPlayed() {
      return this.$store.state.aboutSection2IsPlayed;
    },
    about4hasPlayed() {
      return this.$store.state.aboutSection4IsPlayed;
    },
  },
  watch: {
    $route: {
      handler() {
        this.$store.state.aboutSection2IsPlayed = false;
        this.$store.state.aboutSection4IsPlayed = false;
        this.touchStartPagetY = 0;
        this.normalHidden = false;
        this.whiteShow = false;
      },
      immediate: true,
    },
  },
  mounted() {
    const that = this;
    that.$root.$on('transitionAllEnd', () => {
      that.homeTransitionEnd = true;
    });
    // if (that.$bowser.mobile) {
    //   const onMobileScroll = throttle(that.mobileScroll, 100);
    //   document.addEventListener('scroll', onMobileScroll);
    // }
  },
  methods: {
    onClick() {
      this.$store.state.subMeunSwitch = !this.$store.state.subMeunSwitch;
    },
    mobileScroll() {
      const that = this;
      const windowScrollTop = window.scrollTop || document.documentElement.scrollTop;
      const limit = 100;
      const deltaY = that.touchStartPagetY - window.pageYOffset;
      that.touchStartPagetY = window.pageYOffset;
      if (deltaY < 0) {
        // 往下
        that.normalHidden = windowScrollTop >= limit;
        that.whiteShow = false;
      } else {
        // 往上
        that.whiteShow = windowScrollTop > limit * 3;
        that.normalHidden = windowScrollTop > limit * 3;
      }
    },
  },
};
</script>

<style></style>
